<div class="landing-page">

  <app-vitrine-navbar></app-vitrine-navbar>

  <!-- ── Hero ─────────────────────────────────────────────────────────────── -->
  <section id="hero" class="hero">
    <div class="hero-bg">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>
    <div class="container">
      <div class="hero-content">

        <!-- Texte gauche -->
        <div class="hero-text">
          <div #scrollElement class="badge scroll-hidden">
            <i class="pi pi-bolt"></i> Solution GMAO Nouvelle Génération
          </div>

          <h1 #scrollElement class="hero-title scroll-hidden delay-100">
            La GMAO qui parle <span class="gradient-text">votre langue</span>
          </h1>

          <p #scrollElement class="hero-subtitle scroll-hidden delay-200">
            Ordres de travail, maintenance préventive, suivi des équipements,
            rapports automatiques et assistant IA — centralisés sur une seule plateforme.
          </p>

          <p #scrollElement class="hero-trust scroll-hidden delay-200">
            <i class="pi pi-check-circle"></i> Essai gratuit &nbsp;·&nbsp;
            <i class="pi pi-check-circle"></i> Sans carte bancaire &nbsp;·&nbsp;
            <i class="pi pi-check-circle"></i> On-premise disponible
          </p>

          <!-- Sector selector -->
          <div #scrollElement class="sector-selector scroll-hidden delay-300">
            <span class="sector-selector__label">Je travaille dans :</span>
            <div class="sector-selector__dropdown-wrap">
              <button
                class="sector-selector__trigger"
                (click)="toggleSectorDropdown($event)">
                <i [class]="selectedSectorOption.icon"></i>
                <span>{{ selectedSectorOption.label }}</span>
                <i class="pi pi-angle-down sector-chevron" [class.rotated]="sectorDropdownOpen"></i>
              </button>
              <div class="sector-selector__menu" [class.open]="sectorDropdownOpen">
                <button
                  class="sector-selector__option"
                  *ngFor="let s of sectorOptions"
                  [class.active]="s.id === selectedSector"
                  (click)="selectSector(s.id); $event.stopPropagation()">
                  <i [class]="s.icon"></i>
                  <span>{{ s.label }}</span>
                  <i class="pi pi-check check-icon" *ngIf="s.id === selectedSector"></i>
                </button>
              </div>
            </div>
            <button class="btn btn-primary" (click)="goToSelectedSector()">
              Voir ma solution <i class="pi pi-arrow-right"></i>
            </button>
          </div>

          <!-- Stats -->
          <div class="stats-strip">
            <div #scrollElement class="stat-item scroll-hidden"
              *ngFor="let stat of stats; let i = index"
              [style.transition-delay]="(500 + i * 100) + 'ms'">
              <div class="stat-number">{{ stat.number }}</div>
              <div class="stat-label">{{ stat.label }}</div>
            </div>
          </div>
        </div>

        <!-- Visuel droite -->
        <div #scrollElement class="hero-visual scroll-hidden delay-300">
          <div class="hero-mock">
            <div class="hero-mock__header">
              <span class="hero-mock__dot red"></span>
              <span class="hero-mock__dot yellow"></span>
              <span class="hero-mock__dot green"></span>
              <span class="hero-mock__title">SGMAO · Dashboard</span>
            </div>
            <div class="hero-mock__body">
              <div class="hero-mock__kpis">
                <div class="hero-kpi">
                  <span class="hero-kpi__val">99,2<sup>%</sup></span>
                  <span class="hero-kpi__lbl">Disponibilité</span>
                </div>
                <div class="hero-kpi">
                  <span class="hero-kpi__val hero-kpi__val--green">18</span>
                  <span class="hero-kpi__lbl">Préventives planifiées</span>
                </div>
                <div class="hero-kpi">
                  <span class="hero-kpi__val hero-kpi__val--orange">4</span>
                  <span class="hero-kpi__lbl">Alertes actives</span>
                </div>
              </div>
              <div class="hero-mock__rows">
                <div class="hero-mock__row">
                  <i class="pi pi-check-circle hero-row-icon--green"></i>
                  <div class="hero-row-info">
                    <span class="hero-row-title">Groupe électrogène A3</span>
                    <span class="hero-row-sub">Maintenance préventive · Terminée il y a 1h</span>
                  </div>
                  <span class="hero-row-tag hero-row-tag--green">OK</span>
                </div>
                <div class="hero-mock__row">
                  <i class="pi pi-wrench hero-row-icon--blue"></i>
                  <div class="hero-row-info">
                    <span class="hero-row-title">Compresseur air BP-07</span>
                    <span class="hero-row-sub">Intervention corrective · En cours</span>
                  </div>
                  <span class="hero-row-tag hero-row-tag--blue">En cours</span>
                </div>
                <div class="hero-mock__row">
                  <i class="pi pi-shopping-cart hero-row-icon--purple"></i>
                  <div class="hero-row-info">
                    <span class="hero-row-title">Pompe centrifuge P-12</span>
                    <span class="hero-row-sub">Acquisition · Bon de commande émis</span>
                  </div>
                  <span class="hero-row-tag hero-row-tag--purple">Achat</span>
                </div>
                <div class="hero-mock__row">
                  <i class="pi pi-exclamation-triangle hero-row-icon--orange"></i>
                  <div class="hero-row-info">
                    <span class="hero-row-title">Convoyeur ligne 3</span>
                    <span class="hero-row-sub">Panne signalée · Technicien affecté</span>
                  </div>
                  <span class="hero-row-tag hero-row-tag--orange">Urgent</span>
                </div>
              </div>
            </div>
          </div>
          <div class="hero-float hero-float--tl">
            <i class="pi pi-shield"></i> Données sécurisées
          </div>
          <div class="hero-float hero-float--br">
            <i class="pi pi-bolt"></i> IA intégrée
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ── Sectors strip ─────────────────────────────────────────────────────── -->
  <section class="sectors-strip">
    <div class="container">
      <p class="sectors-label">Adapté aux organisations de tous secteurs</p>
      <div class="sectors-grid">
        <div class="sector-chip"
          *ngFor="let sector of sectors"
          [class.clickable]="sector.id"
          (click)="goToSector(sector.id)">
          <i [class]="sector.icon"></i>
          <span>{{ sector.label }}</span>
          <i class="pi pi-arrow-right chip-arrow" *ngIf="sector.id"></i>
        </div>
      </div>
    </div>
  </section>

  <!-- ── Pain Points ───────────────────────────────────────────────────────── -->
  <section class="pain-points" id="probleme">
    <div class="container">
      <div #scrollElement class="section-header scroll-hidden">
        <span class="section-badge">Le problème</span>
        <h2 class="section-title">La maintenance sans SGMAO, c'est…</h2>
        <p class="section-subtitle">Trois réalités que vivent chaque jour vos équipes sans outil adapté.</p>
      </div>
      <div class="pain-grid">
        <div #scrollElement class="pain-card scroll-hidden" style="transition-delay:0ms">
          <div class="pain-number">01</div>
          <h3>Des pannes imprévues coûteuses</h3>
          <p>Sans suivi préventif, chaque panne devient une urgence. Les arrêts non planifiés paralysent la production et explosent les budgets.</p>
        </div>
        <div #scrollElement class="pain-card scroll-hidden" style="transition-delay:120ms">
          <div class="pain-number">02</div>
          <h3>Un suivi manuel chronophage</h3>
          <p>Fiches papier, tableurs Excel, e-mails perdus… La traçabilité est impossible, l'historique introuvable, les décisions prises à l'aveugle.</p>
        </div>
        <div #scrollElement class="pain-card scroll-hidden" style="transition-delay:240ms">
          <div class="pain-number">03</div>
          <h3>Des équipes déconnectées</h3>
          <p>Techniciens sur le terrain et gestionnaires ne partagent pas la même information. Les priorités divergent, les délais s'allongent.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ── Features Bento ────────────────────────────────────────────────────── -->
  <section id="features" class="features-bento">
    <div class="container">
      <div #scrollElement class="section-header scroll-hidden">
        <span class="section-badge">Fonctionnalités clés</span>
        <h2 class="section-title">Tout ce dont vous avez besoin</h2>
        <p class="section-subtitle">Un outil complet pour piloter votre maintenance du premier signalement jusqu'au rapport final.</p>
      </div>
      <div class="bento-grid">
        <div #scrollElement class="bento-card bento-card--large bento-card--blue scroll-hidden">
          <div class="bento-card__content">
            <div class="bento-card__icon"><i class="pi pi-chart-bar"></i></div>
            <h3>Tableau de bord en temps réel</h3>
            <p>Tous vos KPIs, alertes et performances centralisés sur un seul écran interactif.</p>
            <ul class="bento-list">
              <li><i class="pi pi-check-circle"></i> Graphiques personnalisables</li>
              <li><i class="pi pi-check-circle"></i> Export PDF & Excel</li>
              <li><i class="pi pi-check-circle"></i> Alertes visuelles intelligentes</li>
            </ul>
          </div>
          <div class="bento-metric">
            <span class="metric-number">+99%</span>
            <span class="metric-label">Disponibilité équipements</span>
          </div>
        </div>

        <div #scrollElement class="bento-card bento-card--small bento-card--dark scroll-hidden">
          <div class="bento-card__icon"><i class="pi pi-bolt"></i></div>
          <div class="bento-metric">
            <span class="metric-number">-45%</span>
            <span class="metric-label">Temps d'arrêt non planifié</span>
          </div>
          <p>Grâce à la maintenance préventive automatisée</p>
        </div>

        <div #scrollElement class="bento-card bento-card--small bento-card--green scroll-hidden">
          <div class="bento-card__icon"><i class="pi pi-qrcode"></i></div>
          <div class="bento-metric">
            <span class="metric-number">1 clic</span>
            <span class="metric-label">Pour scanner un équipement</span>
          </div>
          <p>QR codes générés automatiquement pour chaque machine</p>
        </div>

        <div #scrollElement class="bento-card bento-card--medium bento-card--purple scroll-hidden">
          <div class="bento-card__content">
            <div class="bento-card__icon"><i class="pi pi-calendar"></i></div>
            <h3>Gestion des interventions</h3>
            <p>Planifiez, assignez et suivez chaque intervention depuis un calendrier intelligent.</p>
            <ul class="bento-list">
              <li><i class="pi pi-check-circle"></i> Attribution par compétence</li>
              <li><i class="pi pi-check-circle"></i> Notifications push</li>
            </ul>
          </div>
        </div>

        <div #scrollElement class="bento-card bento-card--medium bento-card--amber scroll-hidden">
          <div class="bento-card__content">
            <div class="bento-card__icon"><i class="pi pi-file-pdf"></i></div>
            <h3>Rapports automatiques</h3>
            <p>Générez des rapports complets en quelques secondes pour vos managers et auditeurs.</p>
            <ul class="bento-list">
              <li><i class="pi pi-check-circle"></i> Historique complet</li>
              <li><i class="pi pi-check-circle"></i> Analyse des coûts & ROI</li>
            </ul>
          </div>
          <div class="bento-metric">
            <span class="metric-number">+60%</span>
            <span class="metric-label">Productivité</span>
          </div>
        </div>

        <div #scrollElement class="bento-card bento-card--small bento-card--slate scroll-hidden">
          <div class="bento-card__icon"><i class="pi pi-users"></i></div>
          <div class="bento-metric">
            <span class="metric-number">48h</span>
            <span class="metric-label">Mise en place complète</span>
          </div>
          <p>De la création du compte à la première intervention</p>
        </div>
      </div>
    </div>
  </section>


  <!-- ── Role management ───────────────────────────────────────────────────── -->
  <section id="gestion-roles" class="role-mgmt-section">
    <div class="container">
      <div class="role-mgmt-grid">
        <div #scrollElement class="role-mgmt-text scroll-hidden">
          <span class="section-badge section-badge--light">Administration</span>
          <h2 class="section-title" style="color:white">Créez et attribuez vos propres rôles</h2>
          <p class="role-mgmt-desc">
            Chaque organisation est unique. Avec SGMAO, l'administrateur crée des rôles sur mesure
            et définit précisément ce que chaque collaborateur peut voir ou modifier.
          </p>
          <ul class="role-mgmt-list">
            <li><i class="pi pi-check-circle"></i> Rôles personnalisés par service ou par site</li>
            <li><i class="pi pi-check-circle"></i> Attribution fine des permissions fonctionnelles</li>
            <li><i class="pi pi-check-circle"></i> Gestion multi-organisations et multi-sites</li>
            <li><i class="pi pi-check-circle"></i> Audit log de tous les accès et modifications</li>
            <li><i class="pi pi-check-circle"></i> Activation / désactivation de comptes en un clic</li>
          </ul>
          <button class="btn btn-primary" (click)="goToRegister()">
            Essai gratuit {{ essaiJours }} jours <i class="pi pi-arrow-right"></i>
          </button>
        </div>
        <div #scrollElement class="role-mgmt-visual scroll-hidden">
          <div class="role-cards-demo">
            <div class="demo-role-card demo-role-card--admin">
              <i class="pi pi-shield"></i>
              <div>
                <strong>Administrateur</strong>
                <span>Accès complet · Gestion des rôles</span>
              </div>
            </div>
            <div class="demo-role-card demo-role-card--manager">
              <i class="pi pi-chart-line"></i>
              <div>
                <strong>Gestionnaire</strong>
                <span>Planning · Équipes · Rapports</span>
              </div>
            </div>
            <div class="demo-role-card demo-role-card--agent">
              <i class="pi pi-wrench"></i>
              <div>
                <strong>Technicien</strong>
                <span>Interventions · QR Scan · Terrain</span>
              </div>
            </div>
            <div class="demo-role-card demo-role-card--custom">
              <i class="pi pi-plus-circle"></i>
              <div>
                <strong>Rôle personnalisé…</strong>
                <span>Créez vos propres niveaux d'accès</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ── Comparison ────────────────────────────────────────────────────────── -->
  <section class="comparison" id="comparison">
    <div class="container">
      <div #scrollElement class="section-header scroll-hidden">
        <span class="section-badge">Avant / Après</span>
        <h2 class="section-title">Ce qui change avec SGMAO</h2>
        <p class="section-subtitle">Passez du chaos de la maintenance manuelle à une gestion entièrement maîtrisée.</p>
      </div>
      <div #scrollElement class="comparison-wrapper scroll-hidden">
        <div class="comparison-col comparison-col--before">
          <div class="comparison-col-header">
            <i class="pi pi-times-circle"></i> Sans SGMAO
          </div>
          <ul class="comparison-list">
            <li>Fiches papier et tableurs Excel non synchronisés</li>
            <li>Pannes imprévues paralysant la production</li>
            <li>Historique introuvable, décisions à l'aveugle</li>
            <li>Techniciens déconnectés du bureau</li>
            <li>Rapports produits manuellement, chronophages</li>
            <li>Stocks de pièces de rechange non maîtrisés</li>
          </ul>
        </div>
        <div class="comparison-col comparison-col--after">
          <div class="comparison-col-header">
            <i class="pi pi-check-circle"></i> Avec SGMAO
          </div>
          <ul class="comparison-list">
            <li>Base de données centralisée, traçabilité totale</li>
            <li>Maintenance préventive automatisée, zéro surprise</li>
            <li>Historique complet par équipement en 1 clic</li>
            <li>Notifications push temps réel terrain ↔ bureau</li>
            <li>Rapports générés automatiquement en quelques secondes</li>
            <li>Inventaire piloté avec alertes de seuil automatiques</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- ── Workflow ───────────────────────────────────────────────────────────── -->
  <section id="workflow" class="workflow">
    <div class="container">
      <div #scrollElement class="section-header scroll-hidden">
        <span class="section-badge">Comment ça marche</span>
        <h2 class="section-title">Opérationnel en 3 étapes</h2>
        <p class="section-subtitle">De la création du compte à une maintenance maîtrisée, sans formation longue.</p>
      </div>
      <div class="workflow-steps">
        <div #scrollElement class="workflow-step scroll-hidden" style="transition-delay:0ms">
          <div class="step-num">1</div>
          <div class="step-body">
            <h3>Créez votre espace et ajoutez vos équipements</h3>
            <p>Configurez votre organisation, importez votre parc via Excel ou saisie manuelle. Un QR code est généré automatiquement pour chaque machine.</p>
          </div>
        </div>
        <div #scrollElement class="workflow-step scroll-hidden" style="transition-delay:120ms">
          <div class="step-num">2</div>
          <div class="step-body">
            <h3>Planifiez les maintenances et assignez les équipes</h3>
            <p>Créez des plans de maintenance préventive, assignez les techniciens et laissez SGMAO générer et notifier les interventions automatiquement.</p>
          </div>
        </div>
        <div #scrollElement class="workflow-step scroll-hidden" style="transition-delay:240ms">
          <div class="step-num">3</div>
          <div class="step-body">
            <h3>Pilotez en temps réel et générez vos rapports</h3>
            <p>Tableaux de bord, KPIs, rapports PDF… Suivez la performance de votre maintenance et prenez des décisions éclairées.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ── AI Assistant ───────────────────────────────────────────────────────── -->
  <section id="ai-assistant" class="ai-section">
    <div class="container">
      <div #scrollElement class="ai-highlight scroll-hidden">
        <div class="section-header">
          <span class="section-badge ai-badge">Innovation</span>
          <h2 class="section-title">Assistant IA pour vos maintenanciers</h2>
          <p class="section-subtitle">Un compagnon intelligent qui accompagne vos équipes au quotidien</p>
        </div>
        <div class="ai-content">
          <div class="ai-visual">
            <div class="ai-visual-card">
              <div class="ai-chat-bubble ai-chat-bubble--bot">
                <div class="ai-avatar"><i class="pi pi-bolt"></i></div>
                <div class="ai-bubble-text">À quelle fréquence faut-il réviser ce compresseur ?</div>
              </div>
              <div class="ai-chat-bubble ai-chat-bubble--user">
                <div class="ai-bubble-text">Toutes les <strong>500 heures</strong> selon l'historique. La prochaine échéance est dans <strong>12 jours</strong>.</div>
              </div>
              <div class="ai-chat-bubble ai-chat-bubble--bot">
                <div class="ai-avatar"><i class="pi pi-bolt"></i></div>
                <div class="ai-bubble-text">Rapport généré automatiquement ✓</div>
              </div>
            </div>
          </div>
          <div class="ai-features">
            <h3>Votre assistant intelligent au quotidien</h3>
            <p class="ai-description">Notre assistant IA aide vos maintenanciers à résoudre les problèmes plus rapidement et améliore la productivité de toute l'équipe.</p>
            <ul class="feature-list">
              <li *ngFor="let feature of aiFeatures">
                <span class="check">✓</span>
                <strong>{{ feature.text }}</strong> : {{ feature.detail }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ── Sécurité & Infrastructure ─────────────────────────────────────────── -->
  <section id="techniquement" class="tech-section">
    <div class="container">
      <div #scrollElement class="section-header scroll-hidden">
        <span class="section-badge">Techniquement</span>
        <h2 class="section-title">Sécurité & Infrastructure</h2>
        <p class="section-subtitle">Une plateforme conçue pour les exigences les plus élevées — sécurité, disponibilité et intégrité des données.</p>
      </div>
      <div class="tech-grid">
        <div #scrollElement class="tech-card scroll-hidden"
          *ngFor="let feature of techFeatures; let i = index"
          [class.tech-card--highlight]="feature.highlight"
          [style.transition-delay]="(i * 80) + 'ms'">
          <div class="tech-icon-wrapper">
            <i [class]="feature.icon + ' tech-icon'"></i>
          </div>
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.description }}</p>
          <span class="tech-badge" [class.tech-badge--highlight]="feature.highlight">{{ feature.badge }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- ── Testimonials ───────────────────────────────────────────────────────── -->
  <section class="testimonials" id="testimonials">
    <div class="container">
      <div #scrollElement class="section-header scroll-hidden">
        <span class="section-badge">Témoignages</span>
        <h2 class="section-title">Ce que disent nos clients</h2>
        <p class="section-subtitle">Des équipes de maintenance qui ont transformé leur quotidien avec SGMAO.</p>
      </div>
      <div class="testimonials-grid">
        <div #scrollElement class="testimonial-card scroll-hidden"
          *ngFor="let t of testimonials; let i = index"
          [style.transition-delay]="(i * 120) + 'ms'">
          <div class="testimonial-stars">★★★★★</div>
          <p class="testimonial-content">"{{ t.content }}"</p>
          <div class="testimonial-author">
            <div class="testimonial-avatar">{{ t.author.charAt(0) }}</div>
            <div>
              <strong>{{ t.author }}</strong>
              <span>{{ t.role }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ── Pricing ────────────────────────────────────────────────────────────── -->
  <section class="pricing" id="pricing">
    <div class="container">
      <div #scrollElement class="section-header scroll-hidden">
        <span class="section-badge">Tarifs</span>
        <h2 class="section-title">Des tarifs simples et transparents</h2>
        <p class="section-subtitle">Commencez gratuitement, évoluez selon vos besoins. Sans engagement, sans frais cachés.</p>
      </div>

      <ng-container *ngIf="pricingPlans.length > 0; else noPricing">
        <div #scrollElement class="pricing-grid scroll-hidden">
          <div class="pricing-card"
            [class.pricing-card--recommended]="plan.recommended"
            *ngFor="let plan of pricingPlans; let i = index"
            [style.transition-delay]="(i * 100) + 'ms'">
            <div *ngIf="plan.recommended" class="pricing-badge-recommended">Recommandé</div>
            <div class="pricing-name">{{ plan.name }}</div>
            <div class="pricing-tagline" *ngIf="plan.tagline">{{ plan.tagline }}</div>
            <div class="pricing-price">
              <span class="price-amount">{{ plan.price }}</span>
              <span class="price-unit">FCFA / mois</span>
            </div>
            <ul class="pricing-features">
              <li *ngFor="let f of plan.features">
                <i class="pi pi-check"></i> {{ f }}
              </li>
            </ul>
            <button class="pricing-btn"
              [class.pricing-btn--primary]="plan.recommended"
              [class.pricing-btn--outline]="!plan.recommended"
              (click)="goToRegister()">
              Démarrer l'essai gratuit
            </button>
          </div>
        </div>
      </ng-container>

      <ng-template #noPricing>
        <div #scrollElement class="pricing-contact scroll-hidden">
          <i class="pi pi-tag pricing-contact-icon"></i>
          <p>Tarification sur mesure adaptée à votre organisation et à votre parc d'équipements.</p>
          <button class="btn btn-primary btn-large" (click)="goToContact()">
            <i class="pi pi-envelope"></i> Demander un devis
          </button>
        </div>
      </ng-template>

      <p class="pricing-note">
        ✓ Essai gratuit {{ essaiJours }} jours &nbsp;·&nbsp;
        ✓ Sans carte bancaire &nbsp;·&nbsp;
        ✓ Annulation à tout moment
      </p>
    </div>
  </section>

  <!-- ── FAQ ────────────────────────────────────────────────────────────────── -->
  <section id="faq" class="faq-section">
    <div class="container">
      <div #scrollElement class="section-header scroll-hidden">
        <span class="section-badge">FAQ</span>
        <h2 class="section-title">Questions fréquentes</h2>
        <p class="section-subtitle">Tout ce que vous devez savoir avant de démarrer avec SGMAO.</p>
      </div>
      <div class="faq-list">
        <div #scrollElement class="faq-item scroll-hidden"
          *ngFor="let item of faqItems; let i = index"
          [class.open]="faqOpenIndex === i"
          [style.transition-delay]="(i * 60) + 'ms'"
          (click)="toggleFaq(i)">
          <div class="faq-question">
            <span>{{ item.question }}</span>
            <i class="pi faq-icon" [class.pi-plus]="faqOpenIndex !== i" [class.pi-minus]="faqOpenIndex === i"></i>
          </div>
          <div class="faq-answer">
            <p>{{ item.answer }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ── CTA final ──────────────────────────────────────────────────────────── -->
  <section class="cta">
    <div class="container">
      <div #scrollElement class="cta-content scroll-hidden">
        <h2 class="cta-title">Prêt à transformer votre maintenance ?</h2>
        <p class="cta-description">
          Rejoignez les entreprises qui optimisent déjà leurs opérations avec SGMAO.<br>
          <strong>Essai gratuit {{ essaiJours }} jours · Sans carte bancaire · Formation incluse</strong>
        </p>
        <div class="cta-buttons">
          <button class="btn btn-primary btn-large" (click)="goToRegister()">
            Créer mon compte gratuit
          </button>
          <button class="btn btn-outline-dark btn-large" (click)="goToContact()">
            <i class="pi pi-envelope"></i> Parler à un expert
          </button>
        </div>
        <p class="cta-note">
          ✓ Installation en 48h &nbsp;·&nbsp; ✓ Support 7j/7 &nbsp;·&nbsp; ✓ ROI garanti en 6 mois
        </p>
      </div>
    </div>
  </section>

  <app-vitrine-footer></app-vitrine-footer>

  <!-- ── Scroll to top ──────────────────────────────────────────────────────── -->
  <button class="scroll-top-btn" [class.visible]="showScrollTop" (click)="scrollToTop()" aria-label="Retour en haut">
    <i class="pi pi-arrow-up"></i>
  </button>

  <!-- ── Cookie banner ──────────────────────────────────────────────────────── -->
  <div *ngIf="showCookieConsent" class="cookie-banner">
    <div class="cookie-banner__inner">
      <div class="cookie-banner__text">
        <h4>Gestion des cookies</h4>
        <p>Nous utilisons des cookies pour améliorer votre expérience. En cliquant sur "Accepter", vous consentez à leur utilisation.</p>
      </div>
      <div class="cookie-banner__actions">
        <button class="btn-cookie-refuse" (click)="refuseCookies()">Refuser</button>
        <button class="btn-cookie-accept" (click)="acceptCookies()">Accepter</button>
      </div>
    </div>
  </div>

</div>
